import React from 'react'
import logo from '../../../static/img/logo.svg'

const Navbar = () => (
  <nav
    className='navbar is-transparent bg-dark'
    role='navigation'
    aria-label='main-navigation'
  >
    <div className='container py-2 px-5'>
      <div className='navbar-brand flex items-center text-white text-lg mx-0 p-0'>
        <img className='mr-2' src={logo} alt='SoulCast' style={{ width: '30px' }} />
        Soulcast
      </div>
    </div>
  </nav>
)

export default Navbar
